if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.viewer) return;

      this._lastPlayedSlide = null;
      this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));
      const slider = this.elements.viewer.querySelector('[id^="Slider-"]');
      if (slider) {
        slider.addEventListener('scroll', this.onGalleryScroll.bind(this), { passive: true });
      }
      if (this.elements.thumbnails) {
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
        });
        if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
      }
      const initialActive = this.elements.viewer.querySelector('.product__media-item.is-active');
      if (initialActive) this.playActiveMedia(initialActive);
    }

    onGalleryScroll() {
      const slider = this.elements.viewer.querySelector('[id^="Slider-"]');
      if (!slider) return;
      const slides = Array.from(this.elements.viewer.querySelectorAll('.product__media-item')).filter((el) => el.clientWidth > 0);
      if (slides.length < 2) return;
      const offset = slides[1].offsetLeft - slides[0].offsetLeft;
      if (offset <= 0) return;
      const fractionalPage = slider.scrollLeft / offset;
      const targetPage = Math.min(Math.floor(fractionalPage + 0.8) + 1, slides.length);
      const targetSlide = slides[targetPage - 1];
      if (targetSlide && targetSlide !== this._lastPlayedSlide) {
        this._lastPlayedSlide = targetSlide;
        this.playActiveMedia(targetSlide);
      }
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const activeSlide = event.detail.currentElement;
      this._lastPlayedSlide = activeSlide;
      if (this.elements.thumbnails) {
        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ activeSlide.dataset.mediaId }"]`);
        this.setActiveThumbnail(thumbnail);
      }
      this.playActiveMedia(activeSlide);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) {
        deferredMedia.loadContent(false);
        const video = deferredMedia.querySelector('video');
        if (video) {
          video.play().catch(() => {});
        }
      }
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
